import * as React from 'react';
import {ColumnFilterItem} from 'antd/lib/table';
import locales from '../locales';

export const enum RentalState {
  RENTED = 'RENTED',
  AVAILABLE = 'AVAILABLE',
  RETURNED = 'RETURNED',
  DELETED = 'DELETED',
}

const rentalStates = [
  RentalState.RENTED,
  RentalState.RETURNED,
  RentalState.DELETED,
  RentalState.AVAILABLE
];

const stateToColorClass = {
  [RentalState.RENTED]: 'yellow',
  [RentalState.RETURNED]: 'green',
  [RentalState.AVAILABLE]: 'green',
  [RentalState.DELETED]: 'gray',
};

const stateToText = {
  [RentalState.RENTED]: locales.state_rented,
  [RentalState.RETURNED]: locales.state_returned,
  [RentalState.AVAILABLE]: locales.state_available,
  [RentalState.DELETED]: locales.deleted,
};

export function renderStateElement(state: string | undefined): React.ReactNode {
  const txt = state ? stateToText[state] : locales.state_pending;
  return (
    <div style={{whiteSpace: 'nowrap'}}>
      <span style={{marginRight: 8}}>{txt}</span>
      {renderStateSpan(state)}
    </div>
  );
}

export function renderStateElementCondensed(state: string | undefined): React.ReactNode {
  const txt = state ? stateToText[state] : locales.state_pending;
  return (
    <div style={{textAlign: 'center'}} title={txt}>
      {renderStateSpan(state)}
    </div>
  );
}

export function renderStateSpan(state: string | undefined): React.ReactNode {
  const colorCls = state ? stateToColorClass[state] : 'grey';
  return <span className={'state-dot ' + colorCls}/>;
}

export function getRentalItemStateFilters(): ColumnFilterItem[] {
  return [RentalState.RENTED, RentalState.RETURNED, RentalState.DELETED]
    .map(state => ({text: stateToText[state], value: state}));
}

export function getItemStateFilters(): ColumnFilterItem[] {
  return [RentalState.RENTED, RentalState.AVAILABLE, RentalState.DELETED]
    .map(state => ({text: stateToText[state], value: state}));
}

export function mapItemStateToRentalState(state?: string): RentalState | undefined {
  return rentalStates.find((rs) => rs.toString() === state);
}


// WEBPACK FOOTER //
// ./src/common/state.tsx